// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FirstAnnounce-module--wrapper--1zqf4","imgWrapper":"FirstAnnounce-module--imgWrapper--2MTIG","txtWrapper":"FirstAnnounce-module--txtWrapper--39NsF"};